import ContentType from '@/helpers/contentType';
import CommonMixin from '@/mixins/templates/common';
import CourseMixin from '@/mixins/templates/course';

import { ABtn } from '@maisaedu/ui-components-a-btn';

export default {
  components : { ABtn },
  mixins     : [CommonMixin, CourseMixin],
  props      : {
    showGroup: {
      type    : Boolean,
      default : true
    },
    showModule: {
      type    : Boolean,
      default : true
    },
    showContentAndExercises: {
      type    : Boolean,
      default : true
    },
    showMarketplace: {
      type    : Boolean,
      default : true
    },
    academicMainId: {
      type    : Number,
      default : null
    },
    academicMainTypeId: {
      type    : Number,
      default : null
    },
    parentTopic: {
      type    : Object,
      default : () => ({})
    },
    version: {
      type    : Number,
      default : null
    },
    title: {
      type    : String,
      default : ''
    },
    showModuleGroupOnly: {
      type    : Boolean,
      default : false
    },
    insideModuleGroup: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {

    };
  },
  computed: {
    items() {
      if (this.showModuleGroupOnly) {
        return [
          { title: 'content.selectContentType.moduleGrouper', icon: 'mdi-folder-plus-outline', description: 'content.selectContentType.moduleGrouperDescription', buttonText: 'content.selectContentType.add', isShow: this.showGroup, func: () => this.$emit('selectModuleGroup'), permissionAlias: 'resources_folder_add' }
        ];
      };

      return [
        { title: 'content.selectContentType.moduleGrouper', icon: 'mdi-folder-plus-outline', description: 'content.selectContentType.moduleGrouperDescription', buttonText: 'content.selectContentType.add', isShow: this.showGroup, func: () => this.$emit('selectModuleGroup'), permissionAlias: 'resources_folder_add' },
        { title: 'content.selectContentType.module', icon: 'mdi-post-outline', description: 'content.selectContentType.moduleDescription', buttonText: 'content.selectContentType.add', isShow: this.showModule, func: () => this.emitCreateModule(), permissionAlias: 'resources_page_add' },
        { title: 'content.selectContentType.contentAndExercises', icon: 'mdi-toy-brick-plus-outline', description: 'content.selectContentType.contentAndExercisesDescription', buttonText: 'content.selectContentType.add', isShow: this.showContentAndExercises, func: () => this.emitCreateContentOrExercise(), permissionAliases: ContentType.getPermissions('add') },
        { title: 'content.selectContentType.searchContent', icon: 'mdi-magnify', description: 'content.selectContentType.searchContentDescription', buttonText: 'content.selectContentType.search', isShow: this.showMarketplace, isMarketplace: true, func: () => this.emitCreateContentOrExercise(true), permissionAlias: 'marketplace_add' }
      ];

    },
    filteredItems() {
      return this.items.filter(item => item.isShow);
    },
    verifyItemsLengthAndResize() {
      const countItems = this.filteredItems.length;

      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12;
        case 'sm':
          return countItems > 2 ? 7 : (countItems === 1 ? 8 : 5);
        case 'md':
          return countItems === 1 ? 7 : 5;
        case 'lg':
        case 'xl':
          return countItems >= 3 ? 2 : 4;
      }
    }
  },
  methods: {
    emitCreateContentOrExercise(isMarketplace = false) {
      const params = {
        academicMainId     : this.academicMainId,
        academicMainTypeId : this.academicMainTypeId,
        parentTopic        : this.parentTopic,
        version            : this.version,
        isMarketplace      : isMarketplace
      };

      if (isMarketplace) {
        this.$nuxt.$loading.start();
        this.callMarketPlaceSSO(params);
      } else {
        this.$nuxt.$emit('changeIsOpenModalContentTypes', params);
      }

    },
    callMarketPlaceSSO(item) {
      this.$store.dispatch('_core/auth/actionSSOUrl', 'marketplace-web')
        .then((result) => {
          let urlMarketplace = result;
          if (this.$route.path.indexOf('content') > -1) {
            urlMarketplace = `${urlMarketplace}&modules=false`;
          }

          if (urlMarketplace) {
            this.$nuxt.$emit('changeIsOpenModalContentMarketplace', {
              urlMarketplace,
              version        : item.version,
              academicMainId : item.academicMainId,
              parentTopic    : item.parentTopic
            });
          }

        }).catch((err) => {
          this.$toast.error(err);
        })
        .finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    emitCreateModule() {
      const params = {
        parentTopicId      : this.parentTopic ? this.parentTopic.id : null,
        version            : this.version,
        academicMainId     : this.academicMainId,
        academicMainTypeId : this.academicMainTypeId
      };

      this.$nuxt.$emit('changeIsOpenModalContentPage', params);
    }
  }
};


